module.exports = {"TXTWCL_Popular_Accumulators":{"id":"TXTWCL_Popular_Accumulators","defaultMessage":"Popular Accumulators","ontario":"Popular Parlays"}}